<template>
  <Dialog :open="props.show" @update:open="onClose">
    <DialogContent class="sm:max-w-[500px]">
      <WarningTab v-if="currentTab === 'warning'" @proceed="proceedToCapture" />
      <CaptureTab v-if="currentTab === 'create'" :order="order" @record="createDirectPayment" />
      <SuccessTab v-if="currentTab === 'success'" @close="onClose" />
    </DialogContent>
  </Dialog>
</template>

<script setup lang="ts">
import { Dialog, DialogContent } from '@/components/ui/dialog';
import { ref } from 'vue';
import type { ModelOrderResponse } from '@layup/api-sdk';
import CaptureTab from './tabs/DirectPaymentCreateTab.vue';
import SuccessTab from './tabs/DirectPaymentSuccessTab.vue';
import WarningTab from './tabs/DirectPaymentWarningTab.vue';

const emit = defineEmits(['update:show']);

const props = defineProps<{
  show: boolean;
  order?: ModelOrderResponse;
}>();

const currentTab = ref<'warning' | 'create' | 'success'>('warning');

const proceedToCapture = () => {
  currentTab.value = 'create';
};

const createDirectPayment = () => {
  currentTab.value = 'success';
};

const onClose = () => {
  emit('update:show');
  currentTab.value = 'warning';
};
</script>
